export enum LocalStorageKeys {
  SignedPricings = 'signed-pricings'
}

export function setLocalStorage<T>(key: LocalStorageKeys | string, value: T) {
  localStorage.setItem(key, JSON.stringify(value))
  window.dispatchEvent(new Event('storage'))
}

export function getLocalStorage<T>(key: LocalStorageKeys | string): T | null {
  const item = localStorage.getItem(key)
  if (item === null) return null
  try {
    return JSON.parse(item) as T
  } catch {
    return null
  }
}
